import axios from "axios";
let baseUrl = 'http://fund.iaoe.xyz';
if (window.location.href.indexOf('https') != -1) {
  baseUrl = 'https://fund.iaoe.xyz';
} else {
  baseUrl = 'http://fund.iaoe.xyz';
}
function computeMoney(data) {
  return new Promise((resolve, rejected) => {
    axios({
      // baseURL: baseUrl,
      method: 'get',
      url: '/api/fund/computed_res',
      params: data
    }).then(res => {
      resolve(res);
    }).catch(err=> {
      rejected(err);
    });
  });
}

function computeCount() {
  return new Promise((resolve, rejected) => {
    axios({
      // baseURL: baseUrl,
      method: 'get',
      url: '/api/fund/api_total_use'
    }).then(res => {
      resolve(res);
    }).catch(err=> {
      rejected(err);
    });
  });
}
export {
  computeMoney,
  computeCount
}
